module.exports = __webpack_public_path__ + "static/media/undraw_hiring.a00bb294.svg";